import { NaturalPersonDto } from 'api/actor';
import { ReferentialDto, ReferentialKey } from 'api/referential';
import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import { NaturalPersonFormFieldNames } from 'features/new-actor/enums/naturalPersonFormFieldNames';
import { PersonalInformationFieldNames } from 'features/new-actor/enums/personalInformationFieldNames';
import { NaturalPersonFormValues } from 'features/new-actor/types/optim/naturalPersonFormValues';

import { toDayInput } from 'core/utils/dates';
import { normalizeCountryCode } from './normalizeCountryCode';
export function mapNaturalPerson(
  values: NaturalPersonDto,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>
): NaturalPersonFormValues {

  const getReferentialCode = (referentialKey: ReferentialKey, id?: string | null) => {
    const referential = referentialsData[referentialKey].find((item: any) => item.id === id);
    return referential ? (referential.code as string) : undefined;
  };

  const {
    id,
    civilityId,
    nationalityId,
    birthDate,
    firstName,
    lastName,
    phone,
    address,
    birthName,
    birthCountryId,
    email,
    taxResidenceCountryId,
    isPPE,
    isFPE
  } = values;

  return {
    id,
    [PersonalInformationFieldNames.Civility]: getReferentialCode(ReferentialKey.Civility, civilityId) || '',
    [PersonalInformationFieldNames.FirstName]: firstName,
    [PersonalInformationFieldNames.LastName]: lastName,
    [PersonalInformationFieldNames.BirthName]: birthName,
    // Date calendaire : découpe de string, jamais Date -> toISOString (décale d'un jour)
    [PersonalInformationFieldNames.BirthDate]: toDayInput(birthDate),
    [PersonalInformationFieldNames.Nationality]: getReferentialCode(ReferentialKey.Nationality, nationalityId) || '',
    [PersonalInformationFieldNames.BirthCountry]: getReferentialCode(ReferentialKey.Country, birthCountryId) || '',
    [PersonalInformationFieldNames.Phone]: phone,
    [PersonalInformationFieldNames.Email]: email,
    [AddressFormFieldNames.Address]: address?.line1 ?? '',
    [AddressFormFieldNames.City]: address?.city ?? '',
    [AddressFormFieldNames.AdditionalAddress]: address?.line2 || address?.line3 || undefined,
    [AddressFormFieldNames.PostalCode]: address?.zipCode ?? '',
    [AddressFormFieldNames.Country]: normalizeCountryCode(address?.country, referentialsData),
    // place_id / coordonnées doivent être rechargés pour ne pas invalider l'adresse en édition.
    [AddressFormFieldNames.GooglePlaceId]: address?.googlePlaceId ?? undefined,
    [AddressFormFieldNames.Latitude]: address?.latitude,
    [AddressFormFieldNames.Longitude]: address?.longitude,
    [NaturalPersonFormFieldNames.TaxResidenceCountryId]: getReferentialCode(ReferentialKey.Country, taxResidenceCountryId) || '',
    [NaturalPersonFormFieldNames.IsPPE]: isPPE,
    [NaturalPersonFormFieldNames.IsFPE]: isFPE || false,
  };
}
